import { useParams } from 'react-router-dom';
import { Spacer, TextTitle } from '@pypestream/design-system';
import { AgentRouting } from '@pypestream/api-services/urql';

import { StudioPageProps } from '../hooks/use-pro-studio-routes';
import { WithLoadingState } from '../router';
import { useProStudioCtxSelector } from '../xstate/app.xstate';
import { getChannelsFromPypes } from '../utils';
import { ChannelSettingsForm } from '../components';
import { DefaultFormValues } from '../components/channel-settings-form/channel-settings-form';

type ChannelSettingsPageProps = StudioPageProps;

const ChannelSettingsPage: React.FC<ChannelSettingsPageProps> = () => {
  const { channelId } = useParams();

  const { botPypes } = useProStudioCtxSelector((ctx) => ({
    botPypes: ctx.botPypes || [],
  }));

  const selectedChannel = getChannelsFromPypes(botPypes).find(
    ({ id }) => id === channelId
  );

  const brandMomentUrl =
    selectedChannel?.beta?.customStyling?.brandMomentUrl || '';
  const customStyling = {
    ...(selectedChannel?.beta?.customStyling || {}),
    brandMomentUrl: brandMomentUrl,
  };

  const values: DefaultFormValues = {
    detailsFormValues: {
      name: selectedChannel?.name || '',
      env: selectedChannel?.env || 'sandbox',
      pypeId: selectedChannel?.pypeId || '',
      streamId: selectedChannel?.streamId || '',
      id: selectedChannel?.id || '',
    },
    brandingFormValues: {
      widgetStyleColor: selectedChannel?.style?.widgetStyleColor || '',
      widgetStyleTextColor: selectedChannel?.style?.widgetStyleTextColor || '',
      agentBubbleColor: selectedChannel?.style?.agentBubbleColor || '',
      agentBubbleTextColor: selectedChannel?.style?.agentBubbleTextColor || '',
      userBubbleColor: selectedChannel?.style?.userBubbleColor || '',
      userBubbleTextColor: selectedChannel?.style?.userBubbleTextColor || '',
      name: selectedChannel?.style?.name || 'Web Conversational Interface',
      bannerUrl: selectedChannel?.style?.bannerUrl || '',
      customPypeCss: selectedChannel?.customPypeCss || '',
      brandMomentUrl,
      buttonColor: customStyling.buttonColor || '#000000',
      textColor: customStyling.textColor || '#000000',
      logo: selectedChannel?.logo || '',
    },
    sizingFormValues: {
      widgetWidth: selectedChannel?.style?.widgetWidth || 0,
      widgetHeight: selectedChannel?.style?.widgetHeight || 0,
      shouldLockRatio: selectedChannel?.style?.shouldLockRatio || false,
    },
    agentSupportPlatformFormValues: {
      agentRouting: selectedChannel?.agentRouting || AgentRouting.Pypestream,
      accountId: selectedChannel?.config?.integration_headers?.account_id || '',
      inboxId: selectedChannel?.config?.integration_headers?.inbox_id || '',
      botRetry: selectedChannel?.botRetry || {
        attempts: 3,
        timeout: 35000,
      },
    },
  };

  return selectedChannel ? (
    <>
      <TextTitle test-id="ps-channel-settings-title" size="small">
        Channel Settings
      </TextTitle>
      <Spacer size="large" />
      <ChannelSettingsForm type="update" values={values} />
    </>
  ) : null;
};

export const ChannelSettings = WithLoadingState(ChannelSettingsPage);
